export default "__VITE_ASSET__BwwpDNwE__"